import React from "react";
import { motion } from "framer-motion";
import { BookOpen, Repeat2, Gamepad2 } from "lucide-react";

const EASE = [0.16, 1, 0.3, 1];

const STEPS = [
  {
    icon: BookOpen,
    n: "01",
    title: "Week one: just this",
    body: "Everything below is what I studied in my first week. No paid courses, no video lectures, no bootcamp. I built this guide from scratch to turn the whole exam into patterns I could actually remember. It aims to be complete, though a few gaps may remain.",
  },
  {
    icon: Repeat2,
    n: "02",
    title: "Then: practice questions, non-stop",
    body: "After that week I stopped reading and did nothing but practice questions: the AWS Skill Builder 20-question sets, the official AWS practice exam, and a few other banks, over and over until the patterns became reflex.",
  },
  {
    icon: Gamepad2,
    n: "03",
    title: "How to use it",
    body: "Read a chapter, play with the interactive widgets, then hit the practice quizzes. Every question earns XP, builds streaks, and levels up your rank. Finish all 15 and you complete the guide.",
  },
];

export function Method() {
  return (
    <section className="relative z-10 max-w-[1400px] mx-auto px-5 md:px-10 py-20 md:py-28" data-testid="method">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-60px" }}
        transition={{ duration: 0.7, ease: EASE }}
        className="font-mono-ui text-[10px] uppercase tracking-[0.24em] text-[#2F6F4F] mb-3"
      >
        Read this first
      </motion.div>
      <motion.h2
        initial={{ opacity: 0, y: 24 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-40px" }}
        transition={{ duration: 0.8, ease: EASE }}
        className="font-serif-display text-[34px] md:text-[46px] leading-[1.02] font-medium text-[#1C2430] max-w-3xl mb-12"
      >
        The reading was one week. The practice was everything after.
      </motion.h2>
      <div className="grid md:grid-cols-3 gap-px bg-[var(--border-heavy)] border border-[var(--border-heavy)]">
        {STEPS.map((s, i) => {
          const Icon = s.icon;
          return (
            <motion.div
              key={s.n}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.6, ease: EASE, delay: i * 0.1 }}
              className="bg-[#FBFBF9] p-7 md:p-8"
              data-testid={`method-step-${i}`}
            >
              <div className="flex items-center justify-between mb-5">
                <Icon size={22} strokeWidth={1.6} className="text-[#2F6F4F]" />
                <span className="font-mono-ui text-[11px] tabular-nums text-[#1C2430]/35">{s.n}</span>
              </div>
              <h3 className="font-serif-display text-[24px] leading-tight text-[#1C2430] mb-3">{s.title}</h3>
              <p className="text-[14.5px] leading-relaxed text-[#1C2430]/75">{s.body}</p>
            </motion.div>
          );
        })}
      </div>
    </section>
  );
}
